import { Centrifuge } from 'centrifuge';
import config from '@/config';
import { getItemFromLocalStorage } from '@utils/localStorage';
import { fetchSubDomain } from '@utils/urlHelpers';

export const getCentrifugoAuthToken = async () => {
	const userData = getItemFromLocalStorage(fetchSubDomain());
	const token = userData?.token;

	const response = await fetch(`${config.backendUrl}/centrifugo/token`, {
		method: 'GET',
		headers: {
			authorization: `Bearer ${token}`,
		},
	});
	const data = await response.json();
	return data.token;
};

export const getSubscriptionToken = async (channel, subscriptionTokenType) => {
	const userData = getItemFromLocalStorage(fetchSubDomain());
	const token = userData?.token;

	const response = await fetch(
		`${config.backendUrl}/centrifugo/subscription-token?channel=${encodeURIComponent(channel)}&type=${encodeURIComponent(subscriptionTokenType)}`,
		{
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
			},
		}
	);
	const data = await response.json();
	return data.token;
};

let centrifugeClient = null;

export const getCentrifugoClient = () => {
	if (centrifugeClient) {
		return centrifugeClient;
	}

	centrifugeClient = new Centrifuge(config.centrifugoWsUrl, {
		getToken: getCentrifugoAuthToken,
	});

	return centrifugeClient;
};
